import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.800293 0.817139H7.64955V7.6664H0.800293V0.817139Z",
			fill: "#F35325"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.33496 0.817139H15.1842V7.6664H8.33496V0.817139Z",
			fill: "#81BC06"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0.817383 8.33374H7.66758V15.183H0.817383V8.33374Z",
			fill: "#05A6F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.35205 8.33374H15.2004V15.183H8.35205V8.33374Z",
			fill: "#FFBA08"
		})
	]
});
export default SvgMicrosoftLogo;
